
import React from "react";
import { useState } from 'react';
import { Outlet,Link} from "react-router-dom";
//import pageData from "./PageData";
import Header from "../components/Header";
import Footer from "../components/Footer";
//import ChangePassword from "../Pages/ChangePassword";
//import PrimaryMenu from "../navigator/PrimaryMenu";
import HomeMenu from "../navigator/HomeMenu";
const layout =()=>{ 

//const [imgUrl,setImageUrl] = useState("/assets/images/usersImage/28.jpg");
//const [userName, setUserName] = useState("Naveen"); 
return (
<div className="container">
   <Header/>

   <HomeMenu/>

   <Outlet/>
   <Footer />

</div>




);
}
export default layout;